import type { ChipProps } from "@mui/material";
import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const SChip = styled((props: ChipProps) => <Chip {...props} />)(({ theme }) => ({
    "&.MuiChip-root": {
        transition: "all ease-in-out 0.1s",
        borderRadius: "4px",
        height: "max-content",
        backgroundColor: "var(--backgroundZ2)",
        ".MuiChip-label": {
            fontSize: "12px",
            fontFamily: "Poppins",
            paddingBlock: "2px",
            paddingInline: "8px",
        },
        ".MuiSvgIcon-root": {
            transition: "all ease-in-out 0.1s",
            width: "0px",
        },
        "&:hover": {
            ".MuiSvgIcon-root": {
                transition: "all ease-in-out 0.1s",
                width: "16px",
            },
        },
    },
}));

export default function StyledChip(props: Partial<ChipProps>) {
    return <SChip {...props} />;
}
